import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { CoreRoutingModule } from './core-routing.module';

import { AppComponent } from './app/app.component';
import { RequestService } from './../core/services/request.service';
import { BaseComponent } from './base/base.component';
import { ProcessLoginComponent } from './auth/process-login.component';
import { LoginComponent } from './auth/login.component';
import { AuthService } from './auth/auth.service';
import { AuthTokenInterceptor } from './auth/auth-token.interceptor';
import { SharedModule } from '../shared/shared.module';
import { BreadcrumbComponent } from './base/breadcrumb/breadcrumb.component';
import { NavigationComponent } from './base/header-naviation/navigation.component';
import { SidebarComponent } from './base/sidebar/sidebar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthErrorInterceptor } from './auth/auth-error.interceptor';

export function hostFactory() { return window.location.host; }

@NgModule({ declarations: [
        AppComponent,
        BaseComponent,
        BreadcrumbComponent,
        SidebarComponent,
        NavigationComponent,
        LoginComponent,
        ProcessLoginComponent
    ],
    exports: [
        AppComponent,
        BaseComponent
    ], imports: [RouterModule,
        FormsModule,
        CommonModule,
        CoreRoutingModule,
        SharedModule,
        NgbModule], providers: [
        { provide: 'HOSTNAME', useFactory: hostFactory },
        RequestService,
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthErrorInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule { }